import { useAuth } from "contexts/AuthProvider";
import { tos } from "./legalContent";

/// `required` blocks the app; `review` and `notice` are a banner.
export type ConsentStage = "required" | "review" | "notice" | "none";

interface ConsentState {
  tosAccepted: boolean;
  tosAcceptedBefore: boolean;
  ppAccepted: boolean;
}

/// Someone who accepted earlier Terms keeps working until `acceptBy` (Terms
/// § 19). A Privacy Policy is notice only: it never blocks.
export function consentStage(
  { tosAccepted, tosAcceptedBefore, ppAccepted }: ConsentState,
  acceptBy: string = tos.acceptBy,
  now: number = Date.now(),
): ConsentStage {
  if (!tosAccepted) {
    const inGrace = tosAcceptedBefore && now < Date.parse(acceptBy);
    return inGrace ? "review" : "required";
  }
  return ppAccepted ? "none" : "notice";
}

export function useConsentStage(): ConsentStage {
  return consentStage(useAuth());
}
